// Confirm síncrono no gesto do clique.
// O FormSubmission do Turbo confirma em contexto async; em alguns fluxos o diálogo
// aparece, mas o submit segue mesmo com "Cancelar". Este guard confirma no click
// (capture) e faz o Turbo pular o segundo diálogo quando o usuário já aceitou.

let acceptedForNextTurboConfirm = false

function submitterMessage(submitter) {
  if (!submitter) return null

  const own =
    submitter.getAttribute("data-turbo-confirm") ||
    submitter.getAttribute("data-confirm")
  if (own) return own

  const form = submitter.form || submitter.closest("form")
  if (!form) return null

  return (
    form.getAttribute("data-turbo-confirm") ||
    form.getAttribute("data-confirm")
  )
}

function isSubmitControl(el) {
  if (!(el instanceof HTMLElement)) return false
  if (el.matches("input[type='submit'], input[type='image']")) return true
  if (el.localName !== "button") return false
  const type = (el.getAttribute("type") || "submit").toLowerCase()
  return type === "submit"
}

document.addEventListener(
  "click",
  (event) => {
    const target = event.target
    if (!(target instanceof Element)) return

    const submitter = target.closest("button, input[type='submit'], input[type='image']")
    if (submitter && isSubmitControl(submitter)) {
      const message = submitterMessage(submitter)
      if (!message) return

      if (!window.confirm(message)) {
        event.preventDefault()
        event.stopImmediatePropagation()
        acceptedForNextTurboConfirm = false
        return
      }

      acceptedForNextTurboConfirm = true
      return
    }

    const link = target.closest("a[data-turbo-confirm], a[data-confirm]")
    if (!link) return

    const message =
      link.getAttribute("data-turbo-confirm") || link.getAttribute("data-confirm")
    if (!message) return

    if (!window.confirm(message)) {
      event.preventDefault()
      event.stopImmediatePropagation()
      acceptedForNextTurboConfirm = false
      return
    }

    acceptedForNextTurboConfirm = true
  },
  true
)

export function installTurboConfirmGuard(Turbo) {
  if (!Turbo?.config?.forms) return

  const previous = Turbo.config.forms.confirm

  Turbo.config.forms.confirm = (message, form, submitter) => {
    if (acceptedForNextTurboConfirm) {
      acceptedForNextTurboConfirm = false
      return true
    }

    if (typeof previous === "function") {
      return previous(message, form, submitter)
    }

    return window.confirm(message)
  }
}
